import axios from "axios";
import qs from "qs";
import wx from 'weixin-js-sdk';
import { HTTP_STATUS } from "../constants/status";
import {
  SERVICE_SERVER_BASE_URL,
  LOGIN_HOST,
  ENVIRONMENT,
} from "../config/config";
import { isInMiniprogram } from '../pages/utils';

const params = new URLSearchParams(window.location.href.split("?")[1]);
export const ROUTE = window.location.href.split("?")[0].split("/").pop();

const isSkip =
  params.get("youdaodebug") ||
  ["goods", "oral-show", "lucky-draw", "parentCenter"].includes(ROUTE);
const isWenHao = window.location.href.split("").includes("?");
const passParmas = isWenHao ? "&c=1" : "?c=1";

export function get(url, data) {
  let option = { url, data };

  return request("GET", option);
}

export function post(url, data) {
  let option = { url, data };

  return request("POST", option);
}

function logError(name, action, info) {
  if (!info) {
    info = "empty";
  }

  if (typeof info === "object") {
    info = JSON.stringify(info);
  }

  let time = new Date();
  console.error(time, name, action, info);
}

function handleApiError(res, message, reLogin) {
  return {
    cookies: res.cookies,
    header: res.header,
    data: {
      message,
    },
  };
}

export function handleLogin() {
  if (isInMiniprogram()) {
    wx.miniProgram.navigateTo({url: '/pages/login/home/index'})
    return;
  }
  //判断是否有道域
  if (/^http[s]?:\/\/[^/]*\.(youdao)\.com/.test(window.location.href)) {
    window.location.href = `${LOGIN_HOST}/#/mobile?type=weixin-mp-metams&url=${encodeURIComponent(
      window.location.href
    )}`;
  } else {
    window.location.href = `${LOGIN_HOST}/#/mobile?type=weixin-mp-metams&url=${encodeURIComponent(
      `${window.location.href}${passParmas}`
    )}&goLogIn=true`;
  }
}

function request(method, params) {
  let { url, data } = params;
  let contentType = params.contentType || "application/json";

  const option = {
    method: method,
    url: url.indexOf("http") !== -1 ? url : SERVICE_SERVER_BASE_URL + url,
    headers: {
      "content-type": contentType,
    },
    data: method === "POST" ? data : undefined,
    params: method === "GET" ? data : undefined,
    withCredentials: true,
    paramsSerializer:
      method === "GET"
        ? (params) => {
            return qs.stringify(params, { indices: false });
          }
        : undefined,
  };

  return axios(option)
    .catch((error) => {
      logError("api", "请求接口出现问题", error);
      const res = error.response;

      if (!res) {
        return {
          data: {
            message: "网络错误",
          },
        };
      }

      if (res.status === HTTP_STATUS.NOT_FOUND) {
        return logError("api", "请求资源不存在", url);
      } else if (
        res.status === HTTP_STATUS.BAD_GATEWAY ||
        res.status === HTTP_STATUS.SERVER_ERROR ||
        res.status === HTTP_STATUS.SERVICE_UNAVAILABLE
      ) {
        logError("api", res.status + "服务器开了个小差", url);
        return;
      } else if (res.status === HTTP_STATUS.FORBIDDEN) {
        if (!isSkip) {
          if (!(ENVIRONMENT === "local")) {
            return handleLogin();
          }
        }
      } else if (res.status === HTTP_STATUS.AUTHENTICATE) {
        return handleApiError(res, "先登录后再使用", true);
      } else if (res.status === HTTP_STATUS.CLIENT_ERROR) {
        logError("api", "参数错误", url);

        return handleApiError(res, "参数错误");
      }
      return Promise.reject(error.response);
    })
    .then((res) => {
      if (!res) {
        return;
      }

      if (!res.status) {
        return;
      }

      if (res.data.code === HTTP_STATUS.AUTHENTICATE) {
        return handleApiError(res, "先登录后再使用", true);
      } else if (res.data.code === HTTP_STATUS.FORBIDDEN) {
        return handleApiError(res, "没有权限", true);
      }

      return res.data;
    });
}

export { isSkip };
